// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./_varables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-color {
	 background-color: #141f72;
	 background-color: #fb236a;
}
 /* .account-popup > form button {
	 background-color: hsl(185, 84%, 25%);
} */
 .account-popup > form .cfield i {
	color: hsl(185, 62%, 45%);
}
 .account-popup > form > a {
	color: hsl(185, 62%, 45%);
}
 .account-popup .close-popup {
	 background-color: hsl(184, 77%, 34%);
}
 .layer.color::before {
	 background-color: #141f72;
}
 .pricetable > a {
	 background-color: #141f72;
}
 .pricetable.active {
	 background-color: #141f72;
}
 .pricetable.active > a {
	 color: #141f72;
}
 .bottom-line.style2 {
	 background-color: #141f72;
}
 .text-color {
	 color: #141f72;
	 color: #fb236a;
}
 .pricetable-head h2 {
	 color: #141f72;
}
 .forsticky.sticky .post-job-btn {
	 border: 2px solid #fb236a;
	 background: transparent;
	 color: #fb236a;
}
 .post-job-btn {
	 background-color: #fb236a;
	 border: 2px solid #fb236a;
	 background-color: #fb236a;
}
 .blog-metas a {
	 color: #fb236a;
}
 .blog-metas a::before {
	 background-color: #fb236a;
}
 .menu-sec nav > ul > li > ul li:hover > a {
	 color: #fb236a;
}
 .chosen-container-single .chosen-single div::before {
	 color: #fb236a;
}
 .job-field i {
	 color: #fb236a;
}
 .chosen-container .chosen-results li.highlighted {
	 color: #fb236a;
}
 .active-result.result-selected {
	 color: #fb236a;
}
 .scroll-to a {
	 color: #fb236a;
}
 .p-category > a p {
	 color: #fb236a;
}
 .p-category:hover i {
	 color: #fb236a;
}
 .job-title-sec span {
	 color: #fb236a;
}
 .blog-details .path-title {
	 color: #fff;
	 margin-bottom: 0px;
	 margin-top: 10px;
	 font-size: 14px;
}
 .blog-details > a {
	 color: #fb236a;
	 font-weight: bold;
}
 .border-color {
	 border-color: #fb236a;
}
 .select-user > span.active {
	 border-color: #fb236a;
}
 .browse-all-cat a {
	 border-color: #fb236a;
}
 `, "",{"version":3,"sources":["webpack://./src/assets/scss/colors.css"],"names":[],"mappings":"AACC;EACC,yBAAyB;EACzB,yBAAyB;AAC3B;CACC;;GAEE;CACF;CACA,yBAAyB;AAC1B;CACC;CACA,yBAAyB;AAC1B;CACC;EACC,oCAAoC;AACtC;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,cAAc;AAChB;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,cAAc;EACd,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;CACC;EACC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;CACC;EACC,cAAc;AAChB;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,cAAc;AAChB;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;CACC;EACC,cAAc;EACd,iBAAiB;AACnB;CACC;EACC,qBAAqB;AACvB;CACC;EACC,qBAAqB;AACvB;CACC;EACC,qBAAqB;AACvB","sourcesContent":["@import \"./_varables.css\";\n .bg-color {\n\t background-color: #141f72;\n\t background-color: #fb236a;\n}\n /* .account-popup > form button {\n\t background-color: hsl(185, 84%, 25%);\n} */\n .account-popup > form .cfield i {\n\tcolor: hsl(185, 62%, 45%);\n}\n .account-popup > form > a {\n\tcolor: hsl(185, 62%, 45%);\n}\n .account-popup .close-popup {\n\t background-color: hsl(184, 77%, 34%);\n}\n .layer.color::before {\n\t background-color: #141f72;\n}\n .pricetable > a {\n\t background-color: #141f72;\n}\n .pricetable.active {\n\t background-color: #141f72;\n}\n .pricetable.active > a {\n\t color: #141f72;\n}\n .bottom-line.style2 {\n\t background-color: #141f72;\n}\n .text-color {\n\t color: #141f72;\n\t color: #fb236a;\n}\n .pricetable-head h2 {\n\t color: #141f72;\n}\n .forsticky.sticky .post-job-btn {\n\t border: 2px solid #fb236a;\n\t background: transparent;\n\t color: #fb236a;\n}\n .post-job-btn {\n\t background-color: #fb236a;\n\t border: 2px solid #fb236a;\n\t background-color: #fb236a;\n}\n .blog-metas a {\n\t color: #fb236a;\n}\n .blog-metas a::before {\n\t background-color: #fb236a;\n}\n .menu-sec nav > ul > li > ul li:hover > a {\n\t color: #fb236a;\n}\n .chosen-container-single .chosen-single div::before {\n\t color: #fb236a;\n}\n .job-field i {\n\t color: #fb236a;\n}\n .chosen-container .chosen-results li.highlighted {\n\t color: #fb236a;\n}\n .active-result.result-selected {\n\t color: #fb236a;\n}\n .scroll-to a {\n\t color: #fb236a;\n}\n .p-category > a p {\n\t color: #fb236a;\n}\n .p-category:hover i {\n\t color: #fb236a;\n}\n .job-title-sec span {\n\t color: #fb236a;\n}\n .blog-details .path-title {\n\t color: #fff;\n\t margin-bottom: 0px;\n\t margin-top: 10px;\n\t font-size: 14px;\n}\n .blog-details > a {\n\t color: #fb236a;\n\t font-weight: bold;\n}\n .border-color {\n\t border-color: #fb236a;\n}\n .select-user > span.active {\n\t border-color: #fb236a;\n}\n .browse-all-cat a {\n\t border-color: #fb236a;\n}\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
